<template>
  <v-container fluid grid-list-md fill-height>
    <v-layout row wrap>
      <!-- LOADER -->
      <v-flex xs12 v-show="loader" text-xs-center pt-5 mt-5>
        <v-progress-circular
          dark
          color="#2d4d85"
          indeterminate
          size="128"
        ></v-progress-circular>

        <h2 class="mt-5">Betöltés folyamatban!</h2>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  components: {},
  data: function () {
    return {
      url: this.$route.params.url,
      loader: true,
    };
  },
  methods: {
    chekFreeLessonUrl() {
      axios
        .post(this.$store.getters.getApiUrl + '/api/lesson/free/check', {
          url: this.$data.url,
        })
        .then((response) => {
          if (response.data.method === 'load') {
            //console.log('freeLesson - response: ',response.data);

            //Store its a free lesson
            this.$store.commit('setIsFreeLesson', {
              isFreeLesson: true,
              freeLessonRedirectUrl: response.data.lesson.url_out,
            });

            //Store the current lesson ID
            this.$store.commit('setCurrentLessonId', {
              currentLessonId: response.data.lesson.id,
            });

            //Check free lesson type
            // 1 - CLASSIC
            // 2 - TEST
            // 3 - VIDEO + TEST
            // 4 - VIDEO + TEST + VIDEO

            //Flush incorrect answers
            this.$store.commit('emptyIncorrectAnswers');

            if (response.data.lesson.type == 1) {
              //Redirect to question or proloque
              this.$router.push({
                name: 'freePrologue',
                params: { lessonId: response.data.lesson.id },
              });
            } else if (response.data.lesson.type == 2) {
              //Redirect to test - only test
              this.$router.push({
                name: 'freeTest',
                params: { lessonId: response.data.lesson.id },
              });
            } else {
              //Redirect to video+test or video+test+video
              this.$router.push({
                name: 'freePrologue',
                params: { lessonId: response.data.lesson.id },
              });
            }
          } //Error || Cant find the lesson
          else {
            this.$store.commit('setIsFreeLesson', {
              isFreeLesson: false,
            });

            //Redirect to 404
            this.$router.push({ name: 'PageNotFound' });
          }
        })
        .catch((error) => {
          if (error.length > 0) {
            console.log('question- error: ', error);
          }
        });
    },
  },
  created: function () {
    this.chekFreeLessonUrl();
  },
};
</script>
